export default defineAppConfig({
  components: {
    icons: {
      spritesDir: "/icons/sprites",
    },
  },
  defaultErrorRedirectUrl: "/client/projects",
});
